<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-breadcrumbs class="pl-0 ml-0" :items="breadcrumbs" divider=">">
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <h1>Payment setup</h1>
      </v-col>
      <v-col cols="12">
        <p>
          Configure your account with our payment operator so we know where to
          send you your pay.
        </p>
      </v-col>
      <v-col cols="12" class="d-flex">
        <p>Status of your payment account:</p>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="25"
          v-if="initialLoading"
          class="ml-2"
        >
        </v-progress-circular>
        <v-chip
          small
          class="ml-2"
          :color="
            paymentAccountStatus.toLowerCase() == 'setup successful'
              ? 'green'
              : 'orange'
          "
          v-if="!initialLoading"
          >{{ paymentAccountStatus }}</v-chip
        >
      </v-col>
      <v-col cols="12">
        <v-btn
          color="blue"
          :disabled="initialLoading || setupLoading"
          :loading="setupLoading"
          @click="setPaymentAccountStatus"
        >
          Setup Stripe account
        </v-btn>
      </v-col>
      <v-col cols="6" v-if="errorMsg != ''">
        <v-alert dense outlined text type="error" class="ma-0">{{
          errorMsg
        }}</v-alert>
      </v-col>
      <v-col cols="12" class="d-flex">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-2 mb-2" to="/settings">
          Done - back to settings
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      chained: false,
      paymentAccountStatus: "Not setup",
      initialLoading: true,
      setupLoading: false,
      breadcrumbs: [
        {
          text: "Settings",
          disabled: false,
          href: "/settings",
        },
        {
          text: "Reviewer enrollment - payment setup",
          disabled: true,
        },
      ],
      isValidValue: false,
      errorMsg: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    console.log(this.$route.query.chained);
    if (this.$route.query.chained == "true") {
      this.chained = true;
    }
    this.getPaymentAccountStatus();
  },
  methods: {
    async getPaymentAccountStatus() {
      var dusi = this.$store.getters.getDusi;
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/api/getSettings",
          {
            dusi: dusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            console.log(
              "burny! response.data: " + JSON.stringify(response.data)
            );
            if (response.data?.revPaymentsOk) {
              this.isValidValue = true;
              this.paymentAccountStatus = "Setup successful";
            } else {
              this.isValidValue = false;
              this.paymentAccountStatus = "Not setup";
            }
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
          this.errorMsg = this.$utils.getErrorMsg(error);
        })
        .finally(() => {
          this.initialLoading = false;
        });
    },
    async setPaymentAccountStatus() {
      this.setupLoading = true;
      var dusi = this.$store.getters.getDusi;
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/api/setPaymentSetup",
          {
            dusi: dusi,
            isValid: !this.isValidValue,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
          this.errorMsg = this.$utils.getErrorMsg(error);
        })
        .finally(() => {
          this.getPaymentAccountStatus();
          this.setupLoading = false;
        });
    },
  },
};
</script>
